export enum AIType {
  AGENT = 'agent',
  DASHBOARD = 'dashboard',
}
